import { placementConfigs } from './ad_ops/adPlacementMappings'

export default defineAppConfig({
  nuxtIcon: {},
  openfeature: {
    multiProvider: true,
    localProvider: false,
    queryProvider: true,
  },
  directAdsHostedConfigUrl: '',
  redesignedNtpPaths: [''],
  googleTagManagerId: '',
  omitDefaultCategoryParam: false,
  externalCategories: [{ label: '', href: '' }],
  urls: {
    home: '/',
    article: '/article',
    video: '/video',
  },
  adops: {
    placements: placementConfigs,
    outbrain: {
      installationKey: '',
    },
    taboola: {
      publisherName: '',
    },
    boltive: {
      scriptUrl: '',
    },
  },
})
